exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selRow[data-v-4452698b]{background-color:#fbff94}.tdGradient2[data-v-4452698b]{background:linear-gradient(hsla(0,0%,91%,.4),#fff,#fff)}.custom-cursor[data-v-4452698b]{cursor:ns-resize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4452698b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/ListDocInfo/Components/Tab2_ListHesab.vue
// module id = 547
// module chunks = 0